module.exports = __webpack_public_path__ + "img/music-test-icon9.92a27cf7.png";